import { render, staticRenderFns } from "./officeDetail.vue?vue&type=template&id=09b8e0c4&scoped=true&"
import script from "./officeDetail.vue?vue&type=script&lang=js&"
export * from "./officeDetail.vue?vue&type=script&lang=js&"
import style0 from "./officeDetail.vue?vue&type=style&index=0&id=09b8e0c4&scoped=true&lang=css&"
import style1 from "./officeDetail.vue?vue&type=style&index=1&id=09b8e0c4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b8e0c4",
  null
  
)

export default component.exports